import React from 'react';

import { Typography, Breadcrumbs as MaterialBreadcrumbs, Box } from '@mui/material';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import useStyles from './styles';

type Navigation = {
  url?: string;
  title: string;
};

interface BreadcrumbsProps {
  navigation: Navigation[];
  wrapperClass?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ navigation, wrapperClass = '' }) => {
  const classes = useStyles();

  if (navigation.length === 0) return null;

  const urls = navigation.map((item) => item?.url);

  return (
    <Box className={cx(classes.breadcrumbs, wrapperClass)}>
      <MaterialBreadcrumbs aria-label="breadcrumb">
        {navigation.map((item, i) => {
          if (i !== navigation.length - 1) {
            const url = urls.slice(0, i + 1).join('');

            return (
              <Link data-testid="breadcrumbLink" key={item.url} to={url}>
                <Typography className={classes.crumb}>{item.title}</Typography>
              </Link>
            );
          } else {
            return (
              <Typography
                data-testid="breadcrumbCurrent"
                key={item.title}
                className={classes.lastCrumb}
              >
                {item.title}
              </Typography>
            );
          }
        })}
      </MaterialBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;
